import { render, staticRenderFns } from "./BetaProvideFeedback.vue?vue&type=template&id=d5e10ed8&"
import script from "./BetaProvideFeedback.vue?vue&type=script&lang=ts&"
export * from "./BetaProvideFeedback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports